// extracted by mini-css-extract-plugin
export var anchor = "authorBlock-module--anchor--4f7da";
export var authorBio = "authorBlock-module--authorBio--74525";
export var authorHeading = "authorBlock-module--authorHeading--54a13";
export var authorName = "authorBlock-module--authorName--ed8a7";
export var authorTitle = "authorBlock-module--authorTitle--8e067";
export var text = "authorBlock-module--text--40e8c";